import { render, staticRenderFns } from "./ZiYuanTaiShi.vue?vue&type=template&id=f94049ca&scoped=true&"
import script from "./ZiYuanTaiShi.vue?vue&type=script&lang=js&"
export * from "./ZiYuanTaiShi.vue?vue&type=script&lang=js&"
import style0 from "./ZiYuanTaiShi.vue?vue&type=style&index=0&id=f94049ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94049ca",
  null
  
)

export default component.exports